import { render, staticRenderFns } from "./add_rate.vue?vue&type=template&id=f463348c&scoped=true"
import script from "./add_rate.vue?vue&type=script&lang=js"
export * from "./add_rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f463348c",
  null
  
)

export default component.exports